"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonKinds = void 0;

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ButtonKinds = ['primary', 'secondary', 'danger', 'ghost', 'danger--primary', 'danger--ghost', 'danger--tertiary', 'tertiary'];
exports.ButtonKinds = ButtonKinds;